import * as rpc from "../../common/jsonRpcRoutes";

/**
 * The status the BFF uses for a booking the upstream refuses to hand over
 * (e.g. its deposit window has closed). Every other non-200 is a failure:
 * `RpcError` covers the whole range, including retryable statuses (408, 425,
 * 429), signature and CSRF rejections and upstream faults, all of which carry
 * a body message of their own and none of which a guest should be told is a
 * settled outcome.
 */
const BOOKING_REFUSED_STATUS = 409;

/**
 * The upstream's guest-facing reason for refusing a booking, or null when the
 * failure is anything else and belongs on the error path — with its retry.
 */
export function refusalMessage(error: unknown): string | null {
  if (!(error instanceof rpc.RpcError) || error.status !== BOOKING_REFUSED_STATUS) return null;
  return error.bodyMessage ?? null;
}
